import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Card, CardBody, Button, CardHeader, Spinner, Table, CustomInput,
  FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter, Input,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import qs from 'qs'
import Select from '../../components/Template/Input/Select'
import DataTable from '../../components/Template/Table/DataTable'
import AddFilesCard from './AddFilesCard'
import oikosApi from '../../services/oikos'
import { getOikosApiUrl } from '../../config/backendEnv'
import { notifyError, notifySuccess } from '../../utils/notify'
import { getDocumentTypes } from '../../store/ducks/types'
import { getProjects, getDocuments, getLegalEntities, getIndividuals } from '../../store/ducks/admin'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import { selectValues } from '../../utils/fc'
import './documentsAdd.css'

class Documents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      document: DEFAULT_DOCUMENT,

      addDocumentModalIsOpen: false,
      addDocumentIsLoading: false,

      editDocumentModalIsOpen: false,
      editDocumentIsLoading: false,

      addVinculationModalIsOpen: false,
      addVinculationData: {},

      getDocumentVinculationsIsLoading: false,

      typeFilter: null,
      entityFilter: null,
      objectFilter: null,

      getDocumentsVinculationsIsLoading: false,
      documentsVinculations: null,

      selectedDocuments: [],
      downloadZipIsLoading: false,
      campos: [],
      dadosCampos: {},
      renderCustomFields: false,

      setores: [],
      vinculosTipo: [],
    }

    this.newFilesRef = React.createRef()
  }

  componentDidMount() {
    const {
      getDocumentTypes, getProjects, getDocuments,
      getLegalEntities, getIndividuals,
    } = this.props

    getProjects()
    getDocuments()
    getDocumentTypes()
    getLegalEntities()
    getIndividuals()


    this.getDocumentsVinculations();
    this.carregarSetoresDocumento()
  }

  carregarSetoresDocumento = async () => {
    try {
      const [setoresRes, vinculosRes] = await Promise.all([
        oikosApi.post('/', { action: 'get', table: 'setor', data: { setor_ativo: 1 } }),
        oikosApi.post('/', {
          action: 'get',
          table: 'setorVinc',
          data: { setorVinc_tabRef: 'tpDocumento', setorVinc_ativo: 1 },
        }),
      ])
      const setores = (Array.isArray(setoresRes.data) ? setoresRes.data : [])
        .map(setor => ({ value: setor.setor_id, label: setor.setor_nome }))
        .sort((a, b) => String(a.label).localeCompare(String(b.label), 'pt-BR'))
      this.setState({
        setores,
        vinculosTipo: Array.isArray(vinculosRes.data) ? vinculosRes.data : [],
      })
    } catch (e) {
      notifyError('Não foi possível carregar os setores.')
    }
  }

  opcoesTipoPorSetor = (documentTypes) => {
    const tipos = Array.isArray(documentTypes) ? documentTypes : []
    const setor = this.state.document?.setorResponsavel
    if (!setor?.value) return []
    const ids = new Set(
      this.state.vinculosTipo
        .filter(v => String(v.setor_id) === String(setor.value))
        .map(v => String(v.setorVinc_tabId)),
    )
    return tipos.filter(t => ids.has(String(t.value)))
  }

  componentDidUpdate(prevProps, prevState) {
    // Only run when selectedTipoDocumentoId changes
    if (prevState.document.tpDocumento_id?.value !== this.state.document.tpDocumento_id?.value) {
      this.setState({ dadosCampos: {} });
      this.loadCampos();
    }
  }

  ordenarPorLabel = (lista) => {
    return lista.slice().sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    });
  }

  loadCampos = async () => {
    console.log(this.state.document.tpDocumento_id?.value)
    if (this.state.document.tpDocumento_id) {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'tpDocumentoCampo',
        data: {
          tpDocumento_id: this.state.document.tpDocumento_id?.value
        },
      })}`);

      this.setState({campos: res.data});

      for (const campo of res.data) {
        console.log(campo)
        if (campo.formatoCampo_id === 1) {
          const qualCampoArmazenarAsOptions = campo.tpDocumentoCampo_id;
          const selOptions = await selectValues(campo.tpDocumentoCampo_tabRef, `${campo.tpDocumentoCampo_tabRef}_id`, campo.tpDocumentoCampo_colunaRef)
          const selOptionsSorted = this.ordenarPorLabel(selOptions);
          this.setState(prevState => ({
            campos: prevState.campos.map(campo => campo.tpDocumentoCampo_id === qualCampoArmazenarAsOptions ? {...campo, selOptions: selOptionsSorted} : campo)
          }))
        }
      }
    } else {
      this.setState({campos: []});
    }
  };

  toggleModal = (type) => {
    const {
      addDocumentIsLoading, editDocumentIsLoading,
    } = this.state

    if (addDocumentIsLoading || editDocumentIsLoading) {
      return null
    }

    if (type === 'add') {
      this.setState(prevState => ({
        addDocumentModalIsOpen: !prevState.addDocumentModalIsOpen,
        document: DEFAULT_DOCUMENT,
        addVinculationData: {},
      }))
    } else if (type === 'edit') {
      this.setState(prevState => ({
        editDocumentModalIsOpen: !prevState.editDocumentModalIsOpen,
        document: DEFAULT_DOCUMENT,
        addVinculationData: {},
      }))
    }

    return null
  }

  getDocumentVinculations = async (id) => {
    this.setState({ getDocumentVinculationsIsLoading: true })

    const { individuals, legalEntities, projects, document } = this.state

    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'documentoVinc',
        data: {
          documento_id: id,
        },
      })}`)

      let vinculations = []
      if (res.data?.length > 0) {
        vinculations = res.data.map(v => ({
          entity: ENTITY_TYPES.find(type => type.value === v.documentoVinc_tabRef),
          object: v.documentoVinc_tabRef === 'pf'
            ? individuals?.find(i => i.value === v.documentoVinc_tabId)
            : v.documentoVinc_tabRef === 'pj'
              ? legalEntities?.find(i => i.value === v.documentoVinc_tabId)
              : v.documentoVinc_tabRef === 'proj'
                ? projects?.find(i => i.value === v.documentoVinc_tabId) : null,
        }))
      }

      this.setState({
        getDocumentVinculationsIsLoading: false,
        document: {
          ...document,
          vinculations,
        },
      })
    } catch (e) {
      console.tron.log('Erro ao buscar vinculações do documento.', e)
      notifyError('Erro ao buscar vinculações do documento.')
      this.setState({ getDocumentVinculationsIsLoading: false })
    }
  }

  getDocumentsVinculations = async () => {
    this.setState({ getDocumentsVinculationsIsLoading: true })

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'documentoVinc',
      })

      let vinculations = []
      if (res.data?.length > 0) {
        vinculations = res.data.map(v => ({
          document: v.documento_id,
          entity: ENTITY_TYPES.find(type => type.value === v.documentoVinc_tabRef),
          object: v.documentoVinc_tabId,
        }))
      }

      this.setState({ getDocumentsVinculationsIsLoading: false, documentsVinculations: vinculations })
    } catch (e) {
      console.tron.log('Erro ao buscar vinculações dos documentos.', e)
      notifyError('Erro ao buscar vinculações dos documentos.')
      this.setState({ getDocumentsVinculationsIsLoading: false, documentsVinculations: null })
    }
  }

  handleAddVinculation = () => {
    const { document, addVinculationData } = this.state

    document.vinculations.push({
      entity: addVinculationData.entity,
      object: addVinculationData.object,
    })

    this.setState({ document, addVinculationModalIsOpen: false, addVinculationData: {} })
  }

  handleDeleteVinculation = (vinculationIndex) => {
    const { document } = this.state
    document.vinculations.splice(vinculationIndex, 1)
    this.setState({ document })
  }


  checkCamposObrigatorios = () => {
    for (const campo of this.state.campos) {
      console.log(campo)
      if (campo.tpDocumentoCampo_obrigatorio === 1 && !this.state.dadosCampos[campo.tpDocumentoCampo_label]) {
        notifyError(`O campo "${campo.tpDocumentoCampo_label}" é obrigatório.`)
        return false
      }
    }
    return true
  }

  handleAddDocumentSubmit = async () => {
    this.setState({ addDocumentIsLoading: true })

    const { document } = this.state
    const newFiles = this.newFilesRef?.current?.state?.files

    try {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: document.tpDocumento_id?.value || undefined,
          documento_desc: document.documento_desc || undefined,
          documento_iniVig: document.documento_iniVig ? moment(document.documento_iniVig).format('YYYY-MM-DD') : undefined,
          documento_fimVig: document.documento_fimVig ? moment(document.documento_fimVig).format('YYYY-MM-DD') : undefined,
          documento_dtEmissao: document.documento_dtEmissao ? moment(document.documento_dtEmissao).format('YYYY-MM-DD') : undefined,
          documento_prazo: document.documento_prazo || undefined,
          documento_ref: document.documento_ref || undefined,
          privacidade_id: document.privacidade_id || 2,
        },
      }

      const documentCreated = await oikosApi.post('/', documentBody)

      if (documentCreated.data[0]?.documento_id && document.vinculations.length > 0) {
        await Promise.all(document.vinculations.map(async vinculation => {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: vinculation.entity.value,
              documentoVinc_tabId: vinculation.object.value,
            },
          }

          await oikosApi.post('/', vinculationBody)
        }))
      }

      if (documentCreated.data[0]?.documento_id && newFiles.length > 0) {
        await Promise.all(newFiles.map(async file => {
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)

          const res = await oikosApi.post('/', formData)
          console.tron.log('res upload_file', res)
        }))
      }

      notifySuccess('Documento adicionado com sucesso.')
      this.setState({ addDocumentIsLoading: false, addDocumentModalIsOpen: false })
      this.props.getDocuments()
      this.getDocumentsVinculations()
    } catch (e) {
      notifyError('Não foi possível adicionar o documento.')
      console.tron.log('Não foi possível adicionar o documento.', e)
      this.setState({ addDocumentIsLoading: false })
    }
  }

  handleAddDocumentDinamicFields = async () => {
    this.setState({ addDocumentIsLoading: true })

    const { document } = this.state
    const eModelo = document.estiloDocumento === 'modelo'
    const allNewFiles = this.newFilesRef?.current?.state?.files || []
    const newFiles = eModelo ? allNewFiles.slice(0, 1) : allNewFiles

    if (eModelo) {
      if (!document.setorResponsavel?.value) {
        notifyError('Escolha o setor responsável.')
        this.setState({ addDocumentIsLoading: false })
        return
      }
      if (newFiles.length === 0) {
        notifyError('Anexe o arquivo do modelo.')
        this.setState({ addDocumentIsLoading: false })
        return
      }
      const ePublico = Number(document.privacidade_id) === 1
      if (ePublico && !(document.setoresDisponiveis || []).length) {
        notifyError('Em modelo público, escolha ao menos um setor disponível.')
        this.setState({ addDocumentIsLoading: false })
        return
      }
    } else if (!document.tpDocumento_id?.value) {
      notifyError('Escolha o tipo de documento.')
      this.setState({ addDocumentIsLoading: false })
      return
    }

    if (!eModelo && !this.checkCamposObrigatorios()) {
      this.setState({ addDocumentIsLoading: false })
      return;
    }

    try {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: eModelo
          ? {
            documento_nome: (() => {
              const nomeInformado = String(document.documento_nome || '').trim()
              if (nomeInformado) return nomeInformado
              const arquivoNome = String(
                newFiles[0]?.data?.path
                || newFiles[0]?.data?.name
                || newFiles[0]?.props?.name
                || '',
              ).trim()
              return arquivoNome || undefined
            })(),
            documento_desc: String(document.documento_desc || '').trim() || undefined,
            privacidade_id: document.privacidade_id || 2,
            setor_id: document.setorResponsavel.value,
          }
          : {
            tpDocumento_id: document.tpDocumento_id?.value || undefined,
            documento_desc: document.documento_desc || undefined,
            documento_iniVig: document.documento_iniVig ? moment(document.documento_iniVig).format('YYYY-MM-DD') : undefined,
            documento_fimVig: document.documento_fimVig ? moment(document.documento_fimVig).format('YYYY-MM-DD') : undefined,
            documento_dtEmissao: document.documento_dtEmissao ? moment(document.documento_dtEmissao).format('YYYY-MM-DD') : undefined,
            documento_prazo: document.documento_prazo || undefined,
            documento_ref: document.documento_ref || undefined,
            privacidade_id: document.privacidade_id || 2,
          },
      }

      const documentCreated = await oikosApi.post('/', documentBody)
      const documentoId = documentCreated.data[0]?.documento_id

      // Público: setores disponíveis em setorVinc. Privado: só documento.setor_id (responsável).
      if (eModelo && documentoId && Number(document.privacidade_id) === 1) {
        const setoresParaVinc = document.setoresDisponiveis || []
        if (setoresParaVinc.length > 0) {
          await Promise.all(setoresParaVinc.map(setor => oikosApi.post('/', {
            action: 'insert',
            table: 'setorVinc',
            data: {
              setor_id: setor.value,
              setorVinc_tabRef: 'documento',
              setorVinc_tabId: documentoId,
            },
          })))
        }
      }

      if (!eModelo && documentoId && document.vinculations.length > 0) {
        await Promise.all(document.vinculations.map(async vinculation => {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: vinculation.entity.value,
              documentoVinc_tabId: vinculation.object.value,
            },
          }

          await oikosApi.post('/', vinculationBody)
        }))
      }

      if (documentCreated.data[0]?.documento_id && newFiles.length > 0) {
        await Promise.all(newFiles.map(async file => {
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentoId)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)

          const res = await oikosApi.post('/', formData)
          console.tron.log('res upload_file', res)
        }))
      }

      if (documentoId) {
        for (const campo of this.state.campos) {
          let campoBody = {}
          if(campo.tpDocumentoCampo_type === 'DATETIME') {
            campoBody = {
              action: 'insert',
              table: 'documentoDado',
              data: {
                documento_id: documentoId,
                tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                documentoDado_valor: moment(this.state.dadosCampos[campo.tpDocumentoCampo_label]).format('YYYY-MM-DD') || null,
              },
            }
          } else {
            campoBody = {
              action: 'insert',
              table: 'documentoDado',
              data: {
                documento_id: documentoId,
                tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                documentoDado_valor: this.state.dadosCampos[campo.tpDocumentoCampo_label] || null,
              },
            }
          }

          const res = await oikosApi.post('/', campoBody)
          console.log(res)
        }
      }

      notifySuccess(eModelo ? 'Modelo adicionado ao repositório.' : 'Documento adicionado com sucesso.')
      this.setState({
        addDocumentIsLoading: false,
        addDocumentModalIsOpen: false,
        document: DEFAULT_DOCUMENT,
        renderCustomFields: false,
        campos: [],
        dadosCampos: {},
      })
      if (!eModelo) {
        this.props.getDocuments()
        this.getDocumentsVinculations()
      }
    } catch (e) {
      notifyError(eModelo ? 'Não foi possível adicionar o modelo.' : 'Não foi possível adicionar o documento.')
      console.tron.log('Não foi possível adicionar o documento.', e)
      this.setState({ addDocumentIsLoading: false })
    }
  }

  handleDownloadZipSubmit = async () => {
    try {
      const { selectedDocuments } = this.state

      if (selectedDocuments.length > 0) {
        this.setState({ downloadZipIsLoading: true })

        const data = {
          documento_id: selectedDocuments.map(doc => doc.documento_id),
        }

        // NÃO CONSEGUI FAZER FUNCIONAR A PARTIR DE REQUISIÇÕES GET OU POST!!! :(

        /* const res = await oikosApi.get(`/?${qs.stringify({
          action: 'download_file',
          table: 'documento',
          data,
        })}`, {
          responseType: 'blob',
        }) */

        /* const res = await oikosApi.post('/', {
          action: 'download_file',
          table: 'documento',
          data,
        }, {
          responseType: 'blob',
          headers: {
            Accept: 'application/zip',
            'Content-Type': 'application/zip',
          },
        }) */

        /* const type = res.headers['content-type']
        const contentDisposition = res.headers['content-disposition']
        let filename = 'download.zip'
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^=\n]*=((['"]).*?\2|[^\n]*)/
          const matches = filenameRegex.exec(contentDisposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        } */

        /* const downloadUrl = URL.createObjectURL(new Blob([res.data], { type })) */
        const downloadUrl = `${getOikosApiUrl()}/?${qs.stringify({
          action: 'download_file',
          table: 'documento',
          data,
        })}`
        const link = document.createElement('a')
        link.href = downloadUrl
        /* link.setAttribute('download', filename) */
        document.body.appendChild(link)
        link.click()
        link.remove()
        /* URL.revokeObjectURL(blobUrl) */
        /* saveAs(new Blob([res.data], { type: '' }), filename) */
      } else {
        notifyError('Selecione documentos para poder baixá-los.')
      }
    } catch (e) {
      notifyError('Não foi possível baixar os documentos.')
      console.tron.log('Não foi possível baixar os documentos.', e)
    }

    this.setState({ downloadZipIsLoading: false })
  }

  render() {
    const {
      document,
      addDocumentModalIsOpen, addDocumentIsLoading,
      editDocumentModalIsOpen,
      addVinculationModalIsOpen, addVinculationData,
      getDocumentVinculationsIsLoading,
      typeFilter, entityFilter, objectFilter,
      getDocumentsVinculationsIsLoading, documentsVinculations,
      selectedDocuments, downloadZipIsLoading,
    } = this.state

    const { getDocumentTypesIsLoading, documentTypes } = this.props.types

    const {
      getDocumentsIsLoading, getProjectsIsLoading,
      getLegalEntitiesIsLoading, getIndividualsIsLoading,
    } = this.props.admin

    let { projects, legalEntities, individuals } = this.props.admin

    projects = projects.map(p => ({
      value: p.proj_id,
      label: p.proj_nome,
    }))

    individuals = individuals.map(person => ({
      label: person.pf_nomeExibicao,
      value: person.pf_id,
    }))

    legalEntities = legalEntities.map(person => ({
      label: person.pj_nomefanta,
      value: person.pj_id,
    }))

    let documents = []
    if (this.props.admin.documents?.length > 0 && documentsVinculations && individuals && legalEntities && projects) {
      documents = this.props.admin.documents.map(doc => ({
        ...doc,
        vinculations: documentsVinculations.filter(v => v.document === doc.documento_id),
      }))

      documents = documents.map(doc => {
        if (doc.vinculations.length > 0) {
          return {
            ...doc,
            vinculations: doc.vinculations.map(v => ({
              ...v,
              object: v.entity?.value === 'pf'
                ? individuals?.find(i => i.value === v.object)
                : v.entity?.value === 'pj'
                  ? legalEntities?.find(i => i.value === v.object)
                  : v.entity?.value === 'proj'
                    ? projects?.find(i => i.value === v.object) : null,
            })),
          }
        }

        return doc
      })
    }

    if (addDocumentModalIsOpen) {
      return (
        <>
          <Modal
            centered
            isOpen={addVinculationModalIsOpen}
            toggle={() => this.setState({ addVinculationData: {}, addVinculationModalIsOpen: false })}
          >
            <ModalHeader
              toggle={() => this.setState({
                addVinculationData: {},
                addVinculationModalIsOpen: false,
              })}
            >
              Adicionar vinculação
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>
                  Entidade
                </Label>
                <Select
                  isSearchable
                  options={ENTITY_TYPES}
                  value={addVinculationData?.entity}
                  onChange={e => this.setState({ addVinculationData: { ...addVinculationData, entity: e || null } })}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Objeto
                </Label>
                <Select
                  isSearchable
                  isLoading={getIndividualsIsLoading || getLegalEntitiesIsLoading || getProjectsIsLoading}
                  isDisabled={!addVinculationData?.entity}
                  options={
                    addVinculationData?.entity?.value === 'pf'
                      ? individuals : addVinculationData?.entity?.value === 'pj'
                        ? legalEntities : addVinculationData?.entity?.value === 'proj'
                          ? projects : null
                  }
                  value={addVinculationData?.object}
                  onChange={e => this.setState({ addVinculationData: { ...addVinculationData, object: e || null } })}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ addVinculationData: {}, addVinculationModalIsOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleAddVinculation()}
                disabled={!addVinculationData?.entity || !addVinculationData?.object}
              >
                Adicionar
              </Button>
            </ModalFooter>
          </Modal>


          <div className="doc-add">
          <header className="doc-add__header">
            <h4 className="doc-add__title">
              Adicionar documento
            </h4>
            <Button color="light" size="sm" onClick={() => this.toggleModal('add')}>
              <i className="ri-close-fill font-size-16" />
            </Button>
          </header>

          <div className="doc-add__split">
            <section className="doc-add__zone">
              <Card>
                <CardHeader>
                  Informações
                </CardHeader>
                <CardBody>
                  <div className="doc-add__fields">
                    <Col>
                      <FormGroup>
                        <Label>Estilo de documento</Label>
                        <CustomInput
                          type="radio"
                          id="estiloDocumentoRadio"
                          label="Documento"
                          checked={document.estiloDocumento !== 'modelo'}
                          onChange={() => this.setState({
                            document: {
                              ...document,
                              estiloDocumento: 'documento',
                              setorResponsavel: null,
                              setoresDisponiveis: [],
                              documento_desc: document.documento_desc || '',
                            },
                            renderCustomFields: false,
                            campos: [],
                            dadosCampos: {},
                          })}
                        />
                        <CustomInput
                          type="radio"
                          id="estiloModeloRadio"
                          label="Modelo"
                          checked={document.estiloDocumento === 'modelo'}
                          onChange={() => {
                            const card = this.newFilesRef?.current
                            if (card?.state?.files?.length > 1) {
                              const keep = card.state.files.slice(0, 1)
                              card.state.files.slice(1).forEach((file) => {
                                if (file?.props?.preview) URL.revokeObjectURL(file.props.preview)
                              })
                              card.setState({ files: keep })
                            }
                            this.setState({
                              document: {
                                ...document,
                                estiloDocumento: 'modelo',
                                tpDocumento_id: null,
                                privacidade_id: document.privacidade_id || 2,
                                vinculations: [],
                              },
                              renderCustomFields: false,
                              campos: [],
                              dadosCampos: {},
                              addVinculationModalIsOpen: false,
                              addVinculationData: {},
                            })
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {document.estiloDocumento === 'modelo' && (
                      <>
                        <Col>
                          <FormGroup>
                            <Label>Setor responsável</Label>
                            <Select
                              isSearchable
                              options={this.state.setores}
                              value={document.setorResponsavel || null}
                              onChange={e => this.setState({
                                document: {
                                  ...document,
                                  setorResponsavel: e || null,
                                },
                              })}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Privacidade</Label>
                            <CustomInput
                              type="radio"
                              id="privacidadeAddPrivadoRadio"
                              label="Privado"
                              checked={document.privacidade_id === 2 || !document.privacidade_id}
                              onChange={() => this.setState({
                                document: {
                                  ...document,
                                  privacidade_id: 2,
                                  setoresDisponiveis: [],
                                },
                              })}
                            />
                            <CustomInput
                              type="radio"
                              id="privacidadeAddPublicoRadio"
                              label="Público"
                              checked={document.privacidade_id === 1}
                              onChange={() => this.setState({
                                document: {
                                  ...document,
                                  privacidade_id: 1,
                                },
                              })}
                            />
                          </FormGroup>
                        </Col>
                        {Number(document.privacidade_id) === 1 && (
                          <Col>
                            <FormGroup>
                              <div className="d-flex justify-content-between align-items-end">
                                <Label>Setores disponíveis</Label>
                                <Button
                                  size="sm"
                                  color="link"
                                  className="mb-1 px-0"
                                  type="button"
                                  onClick={() => this.setState({
                                    document: { ...document, setoresDisponiveis: this.state.setores },
                                  })}
                                >
                                  Marcar todos
                                </Button>
                              </div>
                              <Select
                                isMulti
                                isSearchable
                                options={this.state.setores}
                                value={document.setoresDisponiveis || []}
                                onChange={e => this.setState({ document: { ...document, setoresDisponiveis: e || [] } })}
                              />
                            </FormGroup>
                          </Col>
                        )}
                        <Col xs="12" md="6">
                          <FormGroup>
                            <Label>Nome do modelo</Label>
                            <Input
                              value={document.documento_nome || ''}
                              onChange={e => this.setState({
                                document: { ...document, documento_nome: e.target.value || '' },
                              })}
                              placeholder="Se vazio, usa o nome do arquivo anexado"
                            />
                          </FormGroup>
                        </Col>
                        <Col xs="12">
                          <FormGroup>
                            <Label>Descrição</Label>
                            <Input
                              type="textarea"
                              rows={6}
                              value={document.documento_desc || ''}
                              onChange={e => this.setState({
                                document: { ...document, documento_desc: e.target.value || '' },
                              })}
                              placeholder="Descrição do modelo"
                              style={{ minHeight: 140, resize: 'vertical' }}
                            />
                          </FormGroup>
                        </Col>
                      </>
                    )}

                    {document.estiloDocumento !== 'modelo' && (
                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo de documento
                          </Label>
                          <Select
                            isSearchable
                            isLoading={getDocumentTypesIsLoading}
                            isDisabled={getDocumentTypesIsLoading || !documentTypes}
                            placeholder="Selecionar"
                            options={documentTypes || []}
                            value={document.tpDocumento_id?.value ? document.tpDocumento_id : null}
                            onChange={e => {
                              console.tron.log('Tipo de documento selecionado:', e)
                              if (e.value === 25 || e.value === 46 || e.value === 34) {
                                this.setState({ document: { ...document, tpDocumento_id: e || null }, renderCustomFields: true });
                              } else {
                                this.setState({ document: { ...document, tpDocumento_id: e || null }, renderCustomFields: false })
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                    )}

                                        {
                      document.estiloDocumento !== 'modelo' && this.state.renderCustomFields &&

                      (
                        <>
                          <Col>
                            <FormGroup>
                              <Label>
                                Descrição
                              </Label>
                              <Input
                                value={document.documento_desc}
                                onChange={e => this.setState({ document: { ...document, documento_desc: e.target.value || null } })}
                              />
                            </FormGroup>
                          </Col>

                          {this.state.campos.map((campo, index) => {

                            if (campo.formatoCampo_id === 6) {
                              return (
                                <Col>
                                  <FormGroup>
                                    <Label>
                                      {campo.tpDocumentoCampo_label}
                                    </Label>
                                    <DatePicker
                                      placeholderText="__/__/_____"
                                      locale="pt-BR"
                                      className="form-control"
                                      dateFormat="dd/MM/yyyy"
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      selected={this.state.dadosCampos[campo.tpDocumentoCampo_label] ? moment(this.state.dadosCampos[campo.tpDocumentoCampo_label]).toDate() : null}
                                      onChange={date => this.setState({ dadosCampos: { ...this.state.dadosCampos, [campo.tpDocumentoCampo_label]: date } })}
                                    />
                                  </FormGroup>
                                </Col>
                              )
                            }

                            if (campo.formatoCampo_id === 3) {
                              return (
                                <Col>
                                  <FormGroup>
                                    <Label>
                                      {campo.tpDocumentoCampo_label}
                                    </Label>
                                    <Input
                                      value={ this.state.dadosCampos ? this.state.dadosCampos[campo.tpDocumentoCampo_label] : null }
                                      onChange={e => this.setState({ dadosCampos: { ...this.state.dadosCampos, [campo.tpDocumentoCampo_label]: e.target.value } })}
                                    />
                                  </FormGroup>
                                </Col>
                              )
                            }

                            if (campo.formatoCampo_id === 1) {
                              return (
                                <Col>
                                  <FormGroup>
                                    <Label>
                                      {campo.tpDocumentoCampo_label}
                                    </Label>
                                    <Select
                                      isSearchable
                                      isLoading={getDocumentTypesIsLoading}
                                      isDisabled={getDocumentTypesIsLoading || !documentTypes}
                                      options={this.state.campos ? this.state.campos.find(c => c.tpDocumentoCampo_id === campo.tpDocumentoCampo_id).selOptions : []}
                                      value={this.state.dadosCampos ? this.state.dadosCampos[campo.tpDocumentoCampo_label] : null}
                                      onChange={e => this.setState({ dadosCampos: { ...this.state.dadosCampos, [campo.tpDocumentoCampo_label]: e.value } })}
                                    />
                                  </FormGroup>
                                </Col>
                              )
                            }

                            if (campo.formatoCampo_id === 2) {
                              return (
                                <Col>
                                  <FormGroup>
                                    <Label>
                                      {campo.tpDocumentoCampo_label}
                                    </Label>
                                    <MaskedInput
                                      unmask
                                      mask="R$ num"
                                      blocks={{
                                        num: {
                                          mask: Number,
                                          scale: 2, // digits after point 0 for integers
                                          signed: false, // disallow negative
                                          thousandsSeparator: '.', // any single char
                                          padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                          normalizeZeros: false, // appends or removes zeros at ends
                                          radix: ',', // fractional delimiter
                                          min: 0,
                                          max: 1000000000,
                                        },
                                      }}
                                      lazy={false}
                                      value={this.state.dadosCampos ? this.state.dadosCampos[campo.tpDocumentoCampo_label] : ''}
                                      onAccept={value => this.setState({ dadosCampos: { ...this.state.dadosCampos, [campo.tpDocumentoCampo_label]: value } })}
                                    />
                                  </FormGroup>
                                </Col>
                              )
                            }

                            if (campo.formatoCampo_id === 4) {
                              return (
                                <Col>
                                  <FormGroup>
                                    <Label>
                                      {campo.tpDocumentoCampo_label}
                                    </Label>
                                    <Input
                                      type='number'
                                      value={ this.state.dadosCampos ? this.state.dadosCampos[campo.tpDocumentoCampo_label] : null }
                                      onChange={e => this.setState({ dadosCampos: { ...this.state.dadosCampos, [campo.tpDocumentoCampo_label]: e.target.value } })}
                                    />
                                  </FormGroup>
                                </Col>
                              )
                            }
                          })}
                        </>
                      )
                    }

                    {document.estiloDocumento !== 'modelo' && !this.state.renderCustomFields && (
                      <>
                        <Col>
                          <FormGroup>
                            <Label>
                              Data de emissão
                            </Label>
                            <DatePicker
                              placeholderText="__/__/_____"
                              locale="pt-BR"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={document.documento_dtEmissao ? moment(document.documento_dtEmissao).toDate() : null}
                              onChange={date => this.setState({ document: { ...document, documento_dtEmissao: date || null } })}
                            />
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label>
                              Prazo
                            </Label>
                            <Input
                              value={document.documento_prazo}
                              onChange={e => this.setState({ document: { ...document, documento_prazo: e.target.value || null } })}
                            />
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label>
                              Referência
                            </Label>
                            <Input
                              value={document.documento_ref}
                              onChange={e => this.setState({ document: { ...document, documento_ref: e.target.value || null } })}
                            />
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label>
                              Início da vigência
                            </Label>
                            <DatePicker
                              placeholderText="__/__/_____"
                              locale="pt-BR"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={document.documento_iniVig ? moment(document.documento_iniVig).toDate() : null}
                              onChange={date => this.setState({ document: { ...document, documento_iniVig: date || null } })}
                            />
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label>
                              Fim da vigência
                            </Label>
                            <DatePicker
                              placeholderText="__/__/_____"
                              locale="pt-BR"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={document.documento_fimVig ? moment(document.documento_fimVig).toDate() : null}
                              onChange={date => this.setState({ document: { ...document, documento_fimVig: date || null } })}
                            />
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <Label>
                              Descrição
                            </Label>
                            <Input
                              value={document.documento_desc}
                              onChange={e => this.setState({ document: { ...document, documento_desc: e.target.value || null } })}
                            />
                          </FormGroup>
                        </Col>
                      </>
                    )}
                  </div>

                  {document.estiloDocumento !== 'modelo' && (
                    <>
                      <Row>
                        <Col>
                          <Label>
                            Vinculações
                          </Label>
                        </Col>

                        <Col className="d-flex justify-content-end">
                          <Button
                            disabled={getDocumentVinculationsIsLoading}
                            size="sm"
                            color="link"
                            className="mb-1 px-0"
                            onClick={() => this.setState({
                              addVinculationModalIsOpen: true,
                              addVinculationData: {},
                            })}
                          >
                            Adicionar
                          </Button>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <div className="table-responsive">
                            <Table striped bordered>
                              <thead>
                                <tr>
                                  <th>Entidade</th>
                                  <th>Objeto</th>
                                  <th>Ações</th>
                                </tr>
                              </thead>
                              <tbody>
                                {document.vinculations.length > 0 && (
                                  <>
                                    {document.vinculations.map((vinculation, index) => (
                                      <tr>
                                        <td>
                                          {vinculation.entity.label}
                                        </td>
                                        <td>
                                          {vinculation.object.label}
                                        </td>
                                        <td>
                                          <Button
                                            className="my-0 mx-0 px-0 py-0"
                                            color="link"
                                            size="sm"
                                            onClick={() => this.handleDeleteVinculation(index)}
                                          >
                                            Excluir
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                )}
                                {document.vinculations.length <= 0 && (
                                  <tr>
                                    <td />
                                    <td />
                                    <td />
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </section>
            <aside className="doc-add__zone">
              <Card>
                <CardHeader>
                  Anexos
                </CardHeader>
                <CardBody>
                  <AddFilesCard
                    ref={this.newFilesRef}
                    maxFiles={document.estiloDocumento === 'modelo' ? 1 : 10}
                    multiple={document.estiloDocumento !== 'modelo'}
                  />
                </CardBody>
              </Card>
            </aside>
          </div>

          <footer className="doc-add__actions">
            <Button
              type="button"
              className="doc-add__send"
              disabled={addDocumentIsLoading}
              onClick={() => this.handleAddDocumentDinamicFields()}
            >
              Enviar
              {addDocumentIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </footer>
          </div>
        </>
      )
    }

    if (editDocumentModalIsOpen) {
      return (
        <>
          <Modal
            centered
            isOpen={addVinculationModalIsOpen}
            toggle={() => this.setState({ addVinculationData: {}, addVinculationModalIsOpen: false })}
          >
            <ModalHeader
              toggle={() => this.setState({
                addVinculationData: {},
                addVinculationModalIsOpen: false,
              })}
            >
              Adicionar vinculação
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>
                  Entidade
                </Label>
                <Select
                  isSearchable
                  options={ENTITY_TYPES}
                  value={addVinculationData?.entity}
                  onChange={e => this.setState({ addVinculationData: { ...addVinculationData, entity: e || null } })}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Objeto
                </Label>
                <Select
                  isSearchable
                  isLoading={getIndividualsIsLoading || getLegalEntitiesIsLoading || getProjectsIsLoading}
                  isDisabled={!addVinculationData?.entity}
                  options={
                    addVinculationData?.entity?.value === 'pf'
                      ? individuals : addVinculationData?.entity?.value === 'pj'
                        ? legalEntities : addVinculationData?.entity?.value === 'proj'
                          ? projects : null
                  }
                  value={addVinculationData?.object}
                  onChange={e => this.setState({ addVinculationData: { ...addVinculationData, object: e || null } })}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ addVinculationData: {}, addVinculationModalIsOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleAddVinculation()}
                disabled={!addVinculationData?.entity || !addVinculationData?.object}
              >
                Adicionar
              </Button>
            </ModalFooter>
          </Modal>

          <Row>
            <Col>
              <h4>
                Editar documento
              </h4>
            </Col>

            <Col className="d-flex justify-content-end">
              <Button color="light" size="sm" onClick={() => this.toggleModal('edit')}>
                <i className="ri-close-fill font-size-16" />
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardHeader>
                  Informações
                </CardHeader>
                <CardBody>
                  <Row xs={1} sm={2} lg={4}>
                    <Col>
                      <FormGroup>
                        <Label>
                          Tipo de documento
                        </Label>

                        <Select
                          isSearchable
                          isLoading={getDocumentTypesIsLoading}
                          isDisabled={getDocumentTypesIsLoading || !documentTypes}
                          options={documentTypes}
                          value={documentTypes?.find(type => type.value === document.tpDocumento_id)}
                          onChange={e => this.setState({ document: { ...document, tpDocumento_id: e || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Data de emissão
                        </Label>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={document.documento_dtEmissao ? moment(document.documento_dtEmissao).toDate() : null}
                          onChange={date => this.setState({ document: { ...document, documento_dtEmissao: date || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Prazo
                        </Label>
                        <Input
                          value={document.documento_prazo}
                          onChange={e => this.setState({ document: { ...document, documento_prazo: e.target.value || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Referência
                        </Label>
                        <Input
                          value={document.documento_ref}
                          onChange={e => this.setState({ document: { ...document, documento_ref: e.target.value || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Início da vigência
                        </Label>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={document.documento_iniVig ? moment(document.documento_iniVig).toDate() : null}
                          onChange={date => this.setState({ document: { ...document, documento_iniVig: date || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Fim da vigência
                        </Label>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={document.documento_fimVig ? moment(document.documento_fimVig).toDate() : null}
                          onChange={date => this.setState({ document: { ...document, documento_fimVig: date || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Descrição
                        </Label>
                        <Input
                          value={document.documento_desc}
                          onChange={e => this.setState({ document: { ...document, documento_desc: e.target.value || null } })}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label>
                          Privacidade
                        </Label>
                        <CustomInput
                          type="radio"
                          id="privacidadePublicaRadio"
                          label="Privado"
                          checked={Number(document.privacidade_id) === 2 || !document.privacidade_id}
                          onChange={e => this.setState({ document: { ...document, privacidade_id: e.target.value === 'on' ? 2 : 1 } })}
                        />
                        <CustomInput
                          type="radio"
                          id="privacidadePrivadaRadio"
                          label="Público"
                          checked={Number(document.privacidade_id) === 1}
                          onChange={e => this.setState({ document: { ...document, privacidade_id: e.target.value === 'on' ? 1 : 2 } })}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label>
                        Vinculações
                      </Label>

                      {getDocumentVinculationsIsLoading && (
                        <Spinner size="sm" className="ml-2" />
                      )}
                    </Col>

                    <Col className="d-flex justify-content-end">
                      <Button
                        disabled={getDocumentVinculationsIsLoading}
                        size="sm"
                        color="link"
                        className="mb-1 px-0"
                        onClick={() => this.setState({
                          addVinculationModalIsOpen: true,
                          addVinculationData: {},
                        })}
                      >
                        Adicionar
                      </Button>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="table-responsive">
                        <Table striped bordered>
                          <thead>
                            <tr>
                              <th>Entidade</th>
                              <th>Objeto</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {document.vinculations.length > 0 && (
                              <>
                                {document.vinculations.map((vinculation, index) => (
                                  <tr>
                                    <td>
                                      {vinculation.entity.label}
                                    </td>
                                    <td>
                                      {vinculation.object.label}
                                    </td>
                                    <td>
                                      <Button
                                        className="my-0 mx-0 px-0 py-0"
                                        color="link"
                                        size="sm"
                                        onClick={() => this.handleDeleteVinculation(index)}
                                      >
                                        Excluir
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </>
                            )}
                            {document.vinculations.length <= 0 && (
                              <tr>
                                <td />
                                <td />
                                <td />
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  Anexos
                </CardHeader>
                <CardBody>
                  {/* <AddFilesCard ref={this.newFilesRef} /> */}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr className="mt-2 mb-4" />
            </Col>
          </Row>

          <Row>
            <Col className="d-flex justify-content-end">
              <Button
                type="button"
                color="primary"
                className="ml-3"
                disabled={addDocumentIsLoading}
                onClick={() => this.handleAddDocumentSubmit()}
              >
                Enviar
                {addDocumentIsLoading && (
                  <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </Col>
          </Row>
        </>
      )
    }

    if (!addDocumentModalIsOpen && !editDocumentModalIsOpen) {
      if (documents.length > 0) {
        // Filter by Type
        if (typeFilter && typeFilter.length > 0) {
          const type = typeFilter.map(i => i.value)
          documents = documents.filter(document => type.includes(document.tpDocumento_id))
        }

        // Filter by Entity
        if (entityFilter) {
          documents = documents.filter(document => {
            const entities = document.vinculations.map(v => v.entity.value)
            return entityFilter.value.includes(entities)
          })
        }

        // Filter by Object
        if (objectFilter) {
          documents = documents.filter(document => {
            const objects = document.vinculations.map(v => v.object.value)
            return objectFilter.value.toString().includes(objects)
          })
        }
      }

      return (
        <>
          <Row>
            <Col>
              <h4>
                Biblioteca de documentos
              </h4>
            </Col>

            <Col className="d-flex justify-content-end">
              <Button outline color="primary" onClick={() => this.toggleModal('add')}>
                Adicionar
              </Button>
            </Col>
          </Row>

          <Row className="mt-3" xs={1} sm={2} lg={4}>
            <Col>
              <FormGroup>
                <Select
                  isMulti
                  isSearchable
                  isClearable
                  placeholder="Tipo"
                  isLoading={getDocumentTypesIsLoading}
                  isDisabled={!documentTypes}
                  options={documentTypes}
                  value={typeFilter}
                  onChange={typeFilter => this.setState({ typeFilter })}
                />
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Select
                  isSearchable
                  isClearable
                  placeholder="Entidade"
                  options={ENTITY_TYPES}
                  value={entityFilter}
                  onChange={entityFilter => this.setState({ entityFilter, objectFilter: null })}
                />
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Select
                  isSearchable
                  isClearable
                  placeholder="Objeto"
                  isLoading={getIndividualsIsLoading || getLegalEntitiesIsLoading || getProjectsIsLoading}
                  isDisabled={!entityFilter}
                  value={objectFilter}
                  options={entityFilter?.value === 'pf'
                    ? individuals : entityFilter?.value === 'pj'
                      ? legalEntities : entityFilter?.value === 'proj'
                        ? projects : null}
                  onChange={objectFilter => this.setState({ objectFilter })}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody className="pb-1">
                  {(getDocumentsIsLoading || getDocumentTypesIsLoading) && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner size="sm" />
                      </Col>
                    </Row>
                  )}

                  {!getDocumentsIsLoading && documents && !getDocumentsVinculationsIsLoading && documentsVinculations && !getDocumentTypesIsLoading && documentTypes && (
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'documento_id',
                          },
                          {
                            label: 'Tipo',
                            field: 'documento_tipo',
                            sort: 'disabled',
                          },
                          {
                            label: 'Entidades',
                            field: 'entities',
                            sort: 'disabled',
                          },
                          {
                            label: 'Objetos',
                            field: 'objects',
                            sort: 'disabled',
                          },
                          {
                            label: 'Ações',
                            field: 'actions',
                            sort: 'disabled',
                          },
                        ],
                        rows: documents.map((document) => {
                          const type = documentTypes.find(type => type.value === document.tpDocumento_id)
                          return ({
                            ...document,
                            documento_tipo: type?.label,
                            entities: (
                              <div style={{ marginBottom: -12 }}>
                                {document.vinculations?.map(v => <p key={Math.random()}>{v.entity?.label}</p>)}
                              </div>
                            ),
                            objects: (
                              <div style={{ marginBottom: -12 }}>
                                {document.vinculations?.map(v => <p key={Math.random()}>{v.object?.label}</p>)}
                              </div>
                            ),
                            actions: (
                              <div>
                                {!document.isSelected && (
                                  <Button
                                    title="Selecionar"
                                    size="sm"
                                    color="light"
                                    onClick={() => {
                                      if (selectedDocuments.findIndex(d => d.documento_id === document.documento_id) === -1) {
                                        selectedDocuments.push(document)
                                        this.setState({ selectedDocuments })
                                      }
                                    }}
                                  >
                                    <i className="ri-folder-add-fill font-size-16" />
                                  </Button>
                                )}

                                {/* <Button
                                  className="ml-3"
                                  title="Editar"
                                  size="sm"
                                  color="light"
                                  onClick={() => {
                                    this.setState({ document, editDocumentModalIsOpen: true })
                                    this.getDocumentVinculations(document.documento_id)
                                  }}
                                >
                                  <i className="ri-pencil-fill font-size-16" />
                                </Button> */}
                              </div>
                            ),
                          })
                        }),
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <h4>
                Selecionados
              </h4>
            </Col>

            <Col className="d-flex justify-content-end">
              <Button
                outline
                color="primary"
                onClick={() => this.handleDownloadZipSubmit()}
                disabled={downloadZipIsLoading}
              >
                Download
                {downloadZipIsLoading && (
                  <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody className="pb-0">
                  <div className="table-responsive">
                    <Table striped bordered>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Tipo</th>
                          <th>Entidades</th>
                          <th>Objetos</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDocuments.length > 0 && (
                          <>
                            {selectedDocuments.map((document, i) => {
                              const type = documentTypes.find(type => type.value === document.tpDocumento_id)
                              return (
                                <tr key={Math.random()}>
                                  <td>
                                    {document.documento_id}
                                  </td>
                                  <td>
                                    {type?.label}
                                  </td>
                                  <td>
                                    {document.vinculations?.map(v => <p key={Math.random()}>{v.entity?.label}</p>)}
                                  </td>
                                  <td>
                                    {document.vinculations?.map(v => <p key={Math.random()}>{v.object?.label}</p>)}
                                  </td>
                                  <td>
                                    <Button
                                      title="Remover"
                                      size="sm"
                                      color="light"
                                      onClick={() => {
                                        const filtered = selectedDocuments.filter(doc => doc.documento_id !== document.documento_id)
                                        this.setState({ selectedDocuments: filtered })
                                      }}
                                    >
                                      <i className="ri-folder-reduce-fill font-size-16" />
                                    </Button>
                                  </td>
                                </tr>
                              )
                            })}
                          </>
                        )}
                        {selectedDocuments.length <= 0 && (
                          <tr>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  types: state.types,
  admin: state.admin,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getDocumentTypes,
  getProjects,
  getDocuments,
  getLegalEntities,
  getIndividuals,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Documents)

const DEFAULT_DOCUMENT = {
  vinculations: [],
  estiloDocumento: 'documento',
  setorResponsavel: null,
  setoresDisponiveis: [],
  documento_nome: '',
  documento_desc: '',
}

const ENTITY_TYPES = [
  {
    value: 'pf',
    label: 'Pessoa Física',
  },
  {
    value: 'pj',
    label: 'Pessoa Jurídica',
  },
  {
    value: 'proj',
    label: 'Projeto',
  },
  {
    value: 'contrato',
    label: 'Contrato',
  },
]
